module.exports = __webpack_public_path__ + "components/flag/static/square/hu-956c55cddf55601a5304fb9ba4ba8391.svg";